import clsx from 'clsx';
import React, { useContext, useEffect, useRef } from 'react';
import { Element } from '../../element';
import AccordionContext from '../context/context';
import * as styles from '../accordion.styles';

/**
 *
 * @type {typeof import('..').AccordionContent}
 */
const Content = ({ children, className, style, ...props }) => {
  const { expanded } = useContext(AccordionContext);
  const ref = useRef();
  useEffect(() => {
    ref.current.style.setProperty('--accordion-context-height', `${ref.current.scrollHeight}px`);
  }, [children, expanded]);
  return (
    <div ref={ref} className={clsx(styles.components.wrapper, { [styles.variants.expanded]: expanded })}>
      <Element as="div" className={clsx(styles.components.content, className, { [styles.variants.expanded]: expanded })} {...props}>
        {children}
      </Element>
    </div>
  );
};

if (process.env.NODE_ENV !== 'production') {
  Content.displayName = 'Accordion.Content';
}

export default Content;
